import {
    Component,
    ViewChild,
    ViewEncapsulation,
    OnInit,
    Inject,
    Input,
    ElementRef,
    OnDestroy,
    HostListener,
} from '@angular/core';
import {
    FormGroup,
    FormBuilder,
    FormControl,
    Validators,
} from '@angular/forms';
import { ApiService } from 'app/lib/api.service';
import { LogService } from 'app/lib/log.service';
import { UserService } from '../../lib/user.service';
import { User } from '../../models/user';
import { ModalService } from 'app/lib/modal.service';
import { AnalyticEvent } from 'app/lib/analytic-event';
import {
    Router,
    ActivatedRoute,
    ActivatedRouteSnapshot,
    NavigationEnd,
    RoutesRecognized,
} from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import { MenuService } from 'app/lib/menu.service';
import { DATES_CONFIG } from 'app/models/dynamicform';
import { TranslateService } from '@ngx-translate/core';
import { filter, pairwise } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { StorageService } from 'app/lib/storage.service';

@Component({
    selector: 'app-dynamicform-page',
    templateUrl: './dynamicform-page.component.html',
    styleUrls: ['./dynamicform-page.component.scss'],
    standalone: false,
})
export class DynamicformPageComponent implements OnInit {
    user: User;
    dynamicForm: FormGroup;
    formData: any[] = [];
    finalData = [];
    apiDAta: any;
    isSubmitted: boolean = false;
    isAgeValid = false;
    dataLength: number;
    userData: any;
    showInvalid: boolean = false;
    validvalue: any;
    maxval: any;
    minval: any;
    data: any;
    showUserSurvey: boolean;
    showNpsSurvey: boolean;
    showDemographSurvey: boolean;
    isNextBtnDisabled: boolean = false;
    isNextBtn: boolean = false;
    showSaveBtn: boolean = false;
    disableContinueBtn: boolean = true;
    isSaveBtnEnabled: boolean = false;
    optionType: any;
    active = 0;
    scaleData: any;
    @ViewChild('stepper') stepper: MatStepper;
    shownxtques: boolean = false;
    slideIndex: number = 0;
    panelOpenState = false;
    @ViewChild('stepsContainer', { static: true }) stepsContainer: ElementRef;
    slideOpts = {
        slidesPerView: 'auto',
    };
    customFormValidator: any = {};
    months = DATES_CONFIG.MONTHS;
    years: number[] = Array.from(
        { length: 200 },
        (_, i) => new Date().getFullYear() - i
    );
    dates: string[] = [];
    surveyId: any;
    surveyName: any;
    navPath: string = '';
    menuName: string = '';
    surveyType: any;
    optionSelectArr: string[] = [];
    answers: Array<Object> = [];
    showBackbtn: boolean = false;
    translation: any;
    showEmptyHeader: boolean = false;
    showConsent: boolean;
    showAssessment: boolean = true;
    previousUrl: string;
    path: any;
    currentRoute: string;
    routerSubscription: Subscription;
    savedUserQuizId: string = '';
    userFeedbackQnAnswer: any = {};
    isLoaded: boolean = true;
    forceSave: boolean = false;
    isDobMonthOpen = false;
    isDobDateOpen = false;
    isDobYearOpen = false;
    employers: any[] = [];
    filteredEmployers: any[] = [];
    selectedEmployerID: number | null = null;
    selectedEmployerName: string = '';
    employerSearchControl = new FormControl('');
    isEapOrg: boolean = false;
    constructor(
        private fb: FormBuilder,
        private api: ApiService,
        private modalService: ModalService,
        private log: LogService,
        private userService: UserService,
        private router: ActivatedRoute,
        private _router: Router,
        private menuService: MenuService,
        private translate: TranslateService,
        private storage: StorageService
    ) {
        this.userData = this.userService.getUser();
        const data = history.state;
        const snapshot: ActivatedRouteSnapshot = this.router.snapshot;
        this.surveyId = snapshot.params['surveyId'];
        this.surveyName = snapshot.params['surveyType'];
        this.showConsent = this.userService.isShowConsentInOnboarding(
            this.userData
        );
        // this.showAssessment = this.userData && this.userData.forceAssessment;
        this.router.queryParams.subscribe(params => {
            this.navPath = params['navPath'];
            this.menuName = params['menuName'];
            this.path = params['path'];
        });
        if (this.navPath === '/user-onboarding') {
            this.showEmptyHeader = true;
        }
        this.apiDAta = this.surveyName;

        this.api.get('form/' + this.surveyId).subscribe(response => {
            this.data = response['data'];
            const data = {
                data: this.data,
            };
            this.initialize(data);
        });
    }

    ngOnInit(): void {
        this.currentRoute = this._router.url;
        this.routerSubscription = this._router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.currentRoute = event.url;
                const snapshot: ActivatedRouteSnapshot = this.router.snapshot;
                this.surveyId = snapshot.params['surveyId'];
                this.api.get('form/' + this.surveyId).subscribe(response => {
                    this.data = response['data'];
                    this.surveyName = snapshot.params['surveyType'];
                    this.apiDAta = this.surveyName;
                    const data = {
                        data: this.data,
                    };
                    this.initialize(data);
                });
            });
        this.translate.get('dynamicForm').subscribe(res => {
            this.translation = res;
        });
        const daysInMonth = new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 1,
            0
        ).getDate();
        // this.dates = Array.from({ length: daysInMonth }, (_, i) => i + 1);
        this.dates = Array.from({ length: daysInMonth }, (_, i) =>
            (i + 1).toString().padStart(2, '0')
        );
        this._router.events
            .pipe(
                filter((evt: any) => evt instanceof RoutesRecognized),
                pairwise()
            )
            .subscribe((events: RoutesRecognized[]) => {
                this.previousUrl = events[0].urlAfterRedirects;
            });
    }
    ngDoCheck() {}

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    setDobValue(controlName: string, value: any, data: any) {
        this.dynamicForm.get(controlName)?.setValue(value);
        this.valueChange(data, { value }, controlName);
    }

    getMonthLabel(value: any): string {
        const found = this.months?.find(m => m.value === value);
        return found ? found.label : '';
    }

    @HostListener('document:click')
    onDocumentClick() {
        this.isDobMonthOpen = false;
        this.isDobDateOpen = false;
        this.isDobYearOpen = false;
    }

    openDropdown(target: 'month' | 'date' | 'year') {
        this.isDobMonthOpen = target === 'month' ? !this.isDobMonthOpen : false;
        this.isDobDateOpen = target === 'date' ? !this.isDobDateOpen : false;
        this.isDobYearOpen = target === 'year' ? !this.isDobYearOpen : false;
        // move focus into the listbox so its options are reachable
        const isOpen = { month: this.isDobMonthOpen, date: this.isDobDateOpen, year: this.isDobYearOpen }[target];
        if (isOpen) {
            setTimeout(() => {
                const options = this.getDobOptions(target);
                const selected = options.find(o => o.getAttribute('aria-selected') === 'true');
                (selected || options[0])?.focus();
            });
        }
    }

    closeDobDropdown(target: 'month' | 'date' | 'year') {
        this.isDobMonthOpen = false;
        this.isDobDateOpen = false;
        this.isDobYearOpen = false;
        setTimeout(() => document.getElementById(`dob-${target}-trigger`)?.focus());
    }

    /** Arrow / Home / End move between options. Escape and Tab close the list. */
    onDobListKeydown(event: KeyboardEvent, target: 'month' | 'date' | 'year') {
        const options = this.getDobOptions(target);
        const current = options.indexOf(document.activeElement as HTMLElement);
        let next = -1;
        switch (event.key) {
            case 'ArrowDown':
                next = Math.min(current + 1, options.length - 1);
                break;
            case 'ArrowUp':
                next = Math.max(current - 1, 0);
                break;
            case 'Home':
                next = 0;
                break;
            case 'End':
                next = options.length - 1;
                break;
            case 'Escape':
                event.preventDefault();
                this.closeDobDropdown(target);
                return;
            case 'Tab':
                document.getElementById(`dob-${target}-trigger`)?.focus();
                this.isDobMonthOpen = false;
                this.isDobDateOpen = false;
                this.isDobYearOpen = false;
                return;
            default:
                return;
        }
        event.preventDefault();
        options[next]?.focus();
    }

    private getDobOptions(target: 'month' | 'date' | 'year'): HTMLElement[] {
        return Array.from(
            document.querySelectorAll<HTMLElement>(`#dob-${target}-options [role="option"]`)
        );
    }

    initialize(data) {
        this.formData = [];
        if (data['data'] != undefined) {
            let objs = data['data'];
            this.dataLength = objs.length;
            for (let obj of objs) {
                obj[0]['validations'] = JSON.parse(obj[0]['Validations']);
                this.formData.push(obj[0]);
            }
            this.dynamicForm = this.generateFilterForm();
        }

        if (this.surveyName === 'npsSurvey') {
            this.showNpsSurvey = true;
            this.showUserSurvey = false;
        } else if (this.surveyName === 'UserFeedbackSurvey') {
            this.showUserSurvey = true;
            this.showNpsSurvey = false;
        } else {
            this.showDemographSurvey = true;
        }
        this.userData = this.userService.getUser();
        this.loadEmployersIfEap();
        if (this.apiDAta === 'UserFeedbackSurvey') {
            this.userFeedbackQnAnswer = this.storage.get(
                'userFeedbackQnAnswer',
                true
            );
            if (Object.keys(this.userFeedbackQnAnswer).length > 0) {
                this.forceSave = true;
                this.dynamicForm
                    .get(this.userFeedbackQnAnswer['eventData']['Key'])
                    .setValue(this.userFeedbackQnAnswer['data']);
                this.valueChange(
                    this.userFeedbackQnAnswer['eventData'],
                    this.userFeedbackQnAnswer['data']
                );
            }
        } else {
            this.savedUserQuizId = '';
        }
    }

    generateFilterForm() {
        const group: any = {};
        this.formData.forEach((field, index) => {
            field['Key'] = 'qn' + index;

            if (field.Type === 1) {
                group[field.Key] = field.Required
                    ? new FormControl(field.Value || null, Validators.required)
                    : new FormControl(field.Value || null);
            } else if (field.Type === 2) {
                field['options'].forEach((e, i) => {
                    group[field['Key'] + '_' + i] = new FormControl(
                        '',
                        Validators.nullValidator
                    );
                    this.answers.push({ value: e.ID, isAnswered: false });
                });

                group[field.Key] = field.Required
                    ? new FormControl(field.Value || null, Validators.required)
                    : new FormControl(field.Value || null);
            } else if (field.Type === 7) {
                group[field.Key] = new FormControl(field.Value || '');
                field['rangeSelectedBtnId'] = '';
                Object.assign(this.customFormValidator, {
                    [field.Key]: field.Required ? false : true,
                });
                field.options.forEach((option, opIndex) => {
                    option['isSelected'] = false;
                });
            } else if (field.Type === 9) {
                // field.Group === "age" removed
                group['selectedMonth'] = new FormControl(
                    '',
                    Validators.required
                );
                group['selectedYear'] = new FormControl(
                    '',
                    Validators.required
                );
                group['selectedDate'] = new FormControl(
                    '',
                    Validators.required
                );
                group[field.Key] = field.Required
                    ? new FormControl(field.Value || '', Validators.required)
                    : new FormControl(field.Value || '');
            } else if (field.Type === 8) {
                let validators = [
                    Validators.min(field.validations['min']),
                    Validators.max(field.validations['max']),
                ];
                field.Required && validators.push(Validators.required);
                group[field.Key] = new FormControl(
                    field.Value || '',
                    validators
                );
            } else {
                group[field.Key] = field.Required
                    ? new FormControl(field.Value || '', Validators.required)
                    : new FormControl(field.Value || '');
            }
            if (field.hasOwnProperty('sub')) {
                field.sub.forEach((subQuestion, subIndex) => {
                    subQuestion['show'] = false;
                    //subQuestion["Key"] = "qn" + index;
                    subQuestion['Key'] = 'qn' + index + 'sub' + subIndex;
                });
            } else {
                field['sub'] = [
                    {
                        Key: 'qn' + index + 'sub0',
                        Required: 0,
                        Type: 'NA',
                        range: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                    },
                ];
            }
        });
        return new FormGroup(group);
    }

    loadEmployersIfEap() {
        if (!this.showDemographSurvey) return;
        if (this.userData && this.userData.primaryOrganization) {
            const org = this.userData.primaryOrganization;
            if (org.serviceType === 2) {
                this.isEapOrg = true;
                this.api
                    .get('organizations/' + org.id + '/employers/list')
                    .subscribe(
                        (result: any) => {
                            this.employers = result.data || [];
                            this.filteredEmployers = this.employers.slice();
                        },
                        (error: any) => {
                            this.log.error(
                                'Error loading employers: ' + error.message
                            );
                        }
                    );
                // Filter employers as user types in the autocomplete
                this.employerSearchControl.valueChanges.subscribe(
                    (value: string) => {
                        this.filterEmployers(value || '');
                    }
                );
            }
        }
    }

    private calculateAge(dobString: string): number {
        const dob = new Date(dobString);
        const today = new Date();

        let age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
        age--;
        }

        return age;
    }

    filterEmployers(search: string) {
        if (!search) {
            this.filteredEmployers = this.employers.slice();
            return;
        }
        const lower = search.toLowerCase();
        this.filteredEmployers = this.employers.filter((e: any) =>
            e.Name.toLowerCase().includes(lower)
        );
    }

    onEmployerSelected(event: any) {
        const selected = event.option.value;
        if (selected) {
            this.selectedEmployerID = selected.ID;
            this.selectedEmployerName = selected.Name;
        }
    }

    clearEmployerSelection() {
        this.selectedEmployerID = null;
        this.selectedEmployerName = '';
        this.employerSearchControl.setValue('');
        this.filteredEmployers = this.employers.slice();
    }

    displayEmployer(employer: any): string {
        return employer ? employer.Name : '';
    }

    doSave() {
        this.isSubmitted = true;
        this.dynamicForm.markAllAsTouched();
        if (['UserFeedbackSurvey', 'npsSurvey'].includes(this.apiDAta)) {
            this.saveCurrentAnswer(this.slideIndex, true);
        } else {
            if (
                (this.apiDAta === 'npsSurvey' &&
                    (this.isFormValid() || this.dynamicForm.valid)) ||
                (this.apiDAta !== 'npsSurvey' && this.dynamicForm.valid)
            ) {
                this.callDynamicFormSave();
            }
        }
    }

    // Isform Valids
    isValid(subQuestion, index, ev) {
        let isSubQuestionAnswerExist = false;
        this.finalData = this.finalData.filter(data => data.value);
        if (this.isSubmitted && subQuestion.Required) {
            this.dynamicForm.markAllAsTouched();
            const isSubQuestionAnswer = this.finalData.filter(data =>
                subQuestion.options.map(sub => sub.ID).includes(data.name)
            );
            isSubQuestionAnswerExist =
                isSubQuestionAnswer.length == 0 ? true : false;
            return isSubQuestionAnswerExist;
        }
        return isSubQuestionAnswerExist;
    }

    isMainQuestionAnswered(mainQn) {
        let mainQuestionAnswered = false;
        if (this.isSubmitted && mainQn.Required) {
            const mainQnAns = this.finalData.filter(
                data => data.id == mainQn.ID
            );
            mainQuestionAnswered = mainQnAns.length == 0 ? true : false;
            return mainQuestionAnswered;
        }
        return mainQuestionAnswered;
    }

    checkValidDigit(data) {
        let validDigit = false;
        if (data.Required && data.Type === 8) {
            const ageQn = this.finalData.filter(
                findata => findata.id === data.ID
            );

            if (ageQn.length == 0) {
                this.dynamicForm.get(data.Key).markAsTouched();
                this.dynamicForm.get(data.Key).setErrors({
                    notMatched: validDigit,
                });
                return;
            }
            let validvalue = JSON.parse(data.Validations);
            this.maxval = validvalue.max;
            this.minval = validvalue.min;
            validDigit =
                ageQn[0].value >= validvalue.min &&
                ageQn[0].value <= validvalue.max
                    ? true
                    : false;

            if (!validDigit) {
                this.dynamicForm.get(data.Key).markAsTouched();
                this.dynamicForm.get(data.Key).setErrors({
                    notMatched: true,
                });
            } else {
                this.dynamicForm.get(data.Key).markAsUntouched();
                this.dynamicForm.get(data.Key).setErrors(null);
            }
        }
    }

    isNotRequiredQuestion(data) {
        let optionId = this.getOptionId(data);
        if ((data.hasOwnProperty('Required') && data.Required) || optionId) {
            if (optionId != null) {
                let subData = this.getRequiredSubQuestion(optionId, data);
                if (subData === undefined) return true;
                if (subData != null) {
                    return this.isNotRequiredQuestion(subData);
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    getOptionId(data) {
        let finalDetails = this.finalData.filter(
            finalValue => finalValue.id === data.ID
        );
        return finalDetails.length > 0 ? finalDetails[0].value : null;
    }

    getRequiredSubQuestion(questionValue, data) {
        if (!data.hasOwnProperty('sub')) {
            //to do - Need to check the options value in the final data
            return;
        }
        let subData = data.sub.filter(subOption =>
            subOption.range.includes(questionValue)
        );
        return subData.length > 0 ? subData[0] : null;
    }

    // is NPS slider selection and subQuestion validation
    isFormValid() {
        let isAnswered = true;
        for (let i = 0; i < this.formData.length; i++) {
            if (!this.isNotRequiredQuestion(this.formData[i])) {
                isAnswered = false;
                break;
            }
        }
        return isAnswered;
    }

    // Save APi
    callDynamicFormSave() {
        let finalData: any = {
            Type: this.surveyId,
            Data: JSON.stringify(this.finalData),
        };
        if (this.isEapOrg && this.selectedEmployerID) {
            finalData.EmployerID = this.selectedEmployerID;
        }
        this.isSubmitted = false;
        this.log.debug(JSON.stringify(this.finalData));
        this.api.post('form/' + this.surveyId, finalData).subscribe(
            (result: any) => {
                this.userService.reloadUser();
                this.user = this.userService.getUser();
                if (this.apiDAta === 'Demographic') {
                    this.modalService.showAlert(
                        'Success',
                        this.translation.demoSuccess
                    );
                    if (this.navPath === '/user-onboarding') {
                        this.user.demographicCount =
                            this.user.demographicCount > 0
                                ? this.user.demographicCount
                                : 1;
                        if (!this.showConsent && !this.showAssessment) {
                            this.user.onboardingStep = 3;
                            this.userService.setUser(this.user);
                            this.menuService.postDemogrphicSurvey(
                                'app',
                                this.menuName
                            );
                        } else if (!this.showConsent && this.showAssessment) {
                            this.user.onboardingStep = 2;
                            this.userService.setUser(this.user);
                            this.menuService.postDemogrphicSurvey(
                                '/user-onboarding',
                                this.menuName
                            );
                        } else {
                            this.user.onboardingStep = 1;
                            this.userService.setUser(this.user);
                            this.menuService.postDemogrphicSurvey(
                                '/user-onboarding',
                                this.menuName
                            );
                        }
                    } else if (this.path == 'app/my-settings') {
                        this.userService.setUser(this.user);
                        this.menuService.postDemogrphicSurvey(
                            this.path,
                            this.menuName
                        );
                    } else {
                        this.menuService.postDemogrphicSurvey(
                            this.navPath,
                            this.menuName
                        );
                    }
                } else if (this.apiDAta === 'npsSurvey') {
                    this.modalService.showAlert(
                        'Success',
                        this.translation.RatingSuccess
                    );
                    this.user = this.userService.getUser();
                    this._router.navigateByUrl('/app');
                }
                this.log.event(
                    this.apiDAta + ' ' + AnalyticEvent.event.updated
                );
            },
            (error: any) => {
                this.modalService.showAlert('Error', error.message);
            },
            () => {}
        );
    }

    showNPSSurvey() {
        this.showNpsSurvey = true;
        this.surveyId = this.router.snapshot.params['surveyId'];
        this.surveyName = this.router.snapshot.params['surveyType'];
        this.apiDAta = this.surveyName;
        this.api.get('form/' + this.surveyId).subscribe(response => {
            this.data = response['data'];
            const data = {
                data: this.data,
            };
            this.initialize(data);
        });
    }

    // Field type change
    valueChange(data, ev, opt?, checkBoxIndex?) {
        let valueSelected: any;
        this.isSubmitted = false;
        switch (data.Type) {
            case 1: {
                this.optionType = ev.ID;
                valueSelected = {
                    value: data.ID,
                    name: ev.ID,
                    id: ev.QuestionID,
                };
                this.dynamicForm.get(data.Key).setValue(data.ID);
                this.dynamicForm.get(data.Key).updateValueAndValidity();
                const index = this.finalData.findIndex(fd => {
                    return fd.id === ev.QuestionID;
                });
                if (index >= 0) {
                    this.finalData.splice(index, 1);
                } else {
                    this.finalData.push(valueSelected);
                }
                setTimeout(() => {
                    this.onNext();
                }, 100);
                break;
            }
            case 2: { 
                // opt.checked = !opt.checked;
                const checkbox = opt?.target as HTMLInputElement;
                if (!checkbox) {
                    return;
                }
                const isChecked = checkbox.checked;
                ev.checked = isChecked;
                valueSelected = {
                    value: data.ID,
                    name: ev.ID,
                    id: ev.QuestionID,
                };
                this.dynamicForm.get(data.Key).setValue(data.ID);
                const index = this.finalData.findIndex(fd => {
                    return fd.name === ev.ID;
                });
                if (index >= 0) {
                    this.finalData.splice(index, 1);
                    this.optionSelectArr.splice(index, 1);
                } else {
                    this.finalData.push(valueSelected);
                    this.optionSelectArr.push(checkBoxIndex);
                }
                const idx = this.answers.findIndex(fd => {
                    return fd['value'] === ev.ID;
                });
                this.answers[idx]['isAnswered'] =
                    !this.answers[idx]['isAnswered'];
                const hasAnswer = this.finalData.find(fd => {
                    return fd.id === data.ID;
                });
                hasAnswer && this.dynamicForm.get(data.Key).setValue(true);
                if (data.Required && !hasAnswer) {
                    this.dynamicForm
                        .get(data.Key)
                        .setErrors({ required: true });
                }

                break;
            }
            case 4: {
                this.optionType = opt.ID;
                this.dynamicForm.get(data.Key).setValue(opt);
                valueSelected = {
                    value: data.ID,
                    name: opt.ID,
                    id: opt.QuestionID,
                };
                const index = this.finalData.findIndex(fd => {
                    return fd.id === opt.QuestionID;
                });
                if (index >= 0) {
                    this.finalData.splice(index, 1);
                }
                this.finalData.push(valueSelected);
                setTimeout(() => {
                    this.onNext();
                }, 200);
                break;
            }
            case 5:
            case 6:
            case 8: {
                let value: string;

                value = ev;
                this.dynamicForm.get(data.Key).setValue(value);
                valueSelected = {
                    value: value,
                    name: data.options[0].ID,
                    id: data.options[0].QuestionID,
                };
                const index = this.finalData.findIndex(fd => {
                    return fd.name === data.ID;
                });
                if (index >= 0) {
                    this.finalData.splice(index, 1);
                    if (value != '') {
                        this.finalData.push(valueSelected);
                    }
                } else {
                    value != '' && this.finalData.push(valueSelected);
                }
                data.Type == 8 && this.checkValidDigit(data);
                break;
            }
            case 9: {
                let value: string;
                (opt == 'selectedYear' || opt == 'selectedMonth') &&
                    this.updateDates(data, opt);
                if (
                    this.dynamicForm.get('selectedYear').valid &&
                    this.dynamicForm.get('selectedMonth').valid &&
                    this.dynamicForm.get('selectedDate').valid
                ) {
                    value =
                        this.dynamicForm.get('selectedYear').value +
                        '-' +
                        this.dynamicForm.get('selectedMonth').value +
                        '-' +
                        this.dynamicForm.get('selectedDate').value;
                    this.dynamicForm.get(data.Key).setValue(value);

                    valueSelected = {
                        value: value,
                        name: data.options[0].ID,
                        id: data.options[0].QuestionID,
                    };
                    const index = this.finalData.findIndex(fd => {
                        return fd.name === data.options[0].ID;
                    });
                    if (index >= 0) {
                        this.finalData.splice(index, 1);
                    }
                    this.finalData.push(valueSelected);
                }
                break;
            }
            default: {
                valueSelected = {
                    value: data.ID,
                    name: ev.value.ID,
                    id: ev.value.QuestionID,
                };
                const index = this.finalData.findIndex(fd => {
                    return fd.id === ev.value.QuestionID;
                });
                if (index >= 0) {
                    this.finalData.splice(index, 1);
                } else {
                    this.finalData.push(valueSelected);
                }
                break;
            }
        }
    }

    normalizeOptionText(value: any): string {
        return String(value ?? '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim()
            .toLowerCase();
    }

    isPositiveOption(option: any): boolean {
        const text = this.normalizeOptionText(option?.Comment ?? option?.ID ?? '');
        return [
            'yes',
            'si',
            'sí',
            'oui',
            'ja',
            'true',
            'positive',
            'agree',
            'y'
        ].includes(text);
    }

    isNegativeOption(option: any): boolean {
        const text = this.normalizeOptionText(option?.Comment ?? option?.ID ?? '');
        return [
            'no',
            'non',
            'nein',
            'false',
            'negative',
            'disagree',
            'n'
        ].includes(text);
    }

    isAnyOptionSelected(id): boolean {
        const index = this.answers.findIndex(fd => {
            return fd['value'] === id;
        });
        return this.answers[index]['isAnswered'];
    }

    /**
     * Accessible name for a stepper bullet.
     */
    stepStatusLabel(stepIndex: number, isCompleted: boolean): string {
        const total =
            this.formData.length +
            (this.isEapOrg && this.showDemographSurvey && this.employers.length > 0
                ? 1
                : 0);
        const key = isCompleted
            ? 'a11y.stepCompleted'
            : this.slideIndex === stepIndex
              ? 'a11y.stepCurrent'
              : 'a11y.stepNotCompleted';
        return this.translate.instant(key, {
            number: stepIndex + 1,
            total: total,
        });
    }

    nextData() {
        this.disableContinueBtn = true;
        if (this.slideIndex < this.formData.length - 1) {
            this.slideIndex++;
        }
        this.showBackbtn = true;
        if (this.slideIndex === this.formData.length) {
            this.isSaveBtnEnabled = true;
        }
    }

    prevData() {
        this.slideIndex--;
        this.focusCurrentStep();
        if (this.slideIndex === 0) {
            this.showBackbtn = false;
        } else {
            this.showBackbtn = true;
        }
    }

    // NPS number scale selection
    scaleSelectionCompleted(data) {
        this.scaleData = data;
        this.shownxtques = false;
        this.isSaveBtnEnabled = false;
        this.showScaleQuestions();
    }

    showScaleQuestions() {
        this.shownxtques = true;
        if (this.slideIndex === this.formData.length - 1) {
            this.isSaveBtnEnabled = true;
        }
        let data = this.scaleData;
        this.formData[this.slideIndex].options.forEach((option, index) => {
            if (option.ID === this.scaleData.options.ID) {
                option = this.scaleData.options;
            }
        });
        if (this.formData[this.slideIndex].sub) {
            this.formData[this.slideIndex].sub.forEach((subQn, subIndex) => {
                // check the selecetd value exist in the range
                const isAvailable = this.dynamicForm.contains(
                    'qn' + this.slideIndex + 'sub' + subIndex
                );

                if (subQn.range.includes(data.options.OptionValue)) {
                    subQn.show = true;
                    !isAvailable &&
                        this.dynamicForm.addControl(
                            'qn' + this.slideIndex + 'sub' + subIndex,
                            subQn.Required
                                ? new FormControl(subQn.Value || null, [
                                      Validators.required,
                                  ])
                                : new FormControl(subQn.Value || null)
                        );
                } else {
                    isAvailable &&
                        this.dynamicForm.removeControl(
                            'qn' + this.slideIndex + 'sub' + subIndex
                        );
                    const index = this.finalData.findIndex(fd => {
                        return fd.id === subQn.ID;
                    });
                    if (index >= 0) {
                        this.finalData.splice(index, 1);
                    }
                    subQn.show = false;
                }
            });
        } else {
            this.dynamicForm
                .get(this.formData[this.slideIndex].Key)
                .setValue(true);
        }
        this.customFormValidator[this.formData[this.slideIndex].Key] = true;
        const valueSelected = {
            value: data.options.OptionValue,
            name: data.options.ID,
            id: data.options.QuestionID,
        };
        const index = this.finalData.findIndex(fd => {
            return fd.id === data.options.QuestionID;
        });
        if (index >= 0) {
            this.finalData.splice(index, 1);
        }
        this.finalData.push(valueSelected);

        // const hasAnswer = this.finalData.find((fd) => {
        // 	return fd.id === data.options.QuestionID;
        // });
        // if (dataForm.Required && !hasAnswer) {
        // 	this.dynamicForm.get(data.Key).setErrors({ required: true });
        // }
    }

    /** Announced by the aria-live region whenever the visible step changes. */
    get stepAnnouncement(): string {
        return this.stepStatusLabel(this.slideIndex, false);
    }

    /**
     * The previous step is removed from the DOM on a step change, which drops
     * keyboard focus to <body>. Move it to the new step's question instead.
     */
    private focusCurrentStep() {
        setTimeout(() => {
            const visible = (sel: string) =>
                Array.from(
                    document.querySelectorAll<HTMLElement>(`.app-l-feedback-container ${sel}`)
                ).find(el => el.offsetParent !== null);
            const target =
                visible('.app-c-stepper__question-block') || visible('.formContainer_body');
            if (target) {
                target.setAttribute('tabindex', '-1');
                target.focus();
            }
        });
    }

    /** Only single-choice questions (types 1 and 4) advance on selection — see valueChange(). */
    get currentStepAutoAdvances(): boolean {
        const type = this.formData[this.slideIndex]?.Type;
        return type === 1 || type === 4;
    }

    onNext() {
        const hasEmployerStep = this.isEapOrg && this.employers.length > 0;
        const maxIndex = hasEmployerStep
            ? this.formData.length
            : this.formData.length - 1;
        if (this.slideIndex >= maxIndex) {
            return;
        }
        if (['UserFeedbackSurvey', 'npsSurvey'].includes(this.apiDAta)) {
            this.saveCurrentAnswer(this.slideIndex, false);
        } else {

           const currentField = this.formData[this.slideIndex];
            if (currentField && currentField.Type === 9) {
                const dobControl = this.dynamicForm.get(currentField.Key);
                if (dobControl && dobControl.value) {
                    const age = this.calculateAge(dobControl.value);
                    if (age <= 12) {
                        this.modalService.showAlert(
                            'Error',
                            this.translate.instant('dynamicForm.ageBelowThreshold')
                        );
                        return;
                    }
                }
            }

            this.slideIndex++;
            this.focusCurrentStep();

            if (this.slideIndex >= this.formData.length) {
                return;
            }
            const index = this.finalData.findIndex(fd => {
                return fd.id === this.formData[this.slideIndex].ID;
            });
            this.optionType =
                this.finalData[index] && this.finalData[index].name
                    ? this.finalData[index].name
                    : '';
        }
    }

    saveCurrentAnswer(questionIndex: number, isComplete: boolean) {
        this.isLoaded = false;
        const currentConfig = this.formData[questionIndex];
        let currentQuestionAnswer = [];
        const collectAnswerById = (id: any) => {
            const answer = this.finalData.filter(fd => fd.id === id);
            if (answer?.length) currentQuestionAnswer.push(...answer);
        };
        collectAnswerById(currentConfig.ID);
        currentConfig.sub?.forEach(subItem => collectAnswerById(subItem.ID));

        let payload = {
            Type: this.surveyId,
            UserQuizID: this.savedUserQuizId || null,
            Data: JSON.stringify(currentQuestionAnswer),
        };
        if (
            this.apiDAta === 'UserFeedbackSurvey' &&
            this.slideIndex === 0 &&
            this.forceSave
        ) {
            payload['force'] = true;
        }

        this.user = this.userService.getUser();
        this.api.post('form/save/' + this.surveyId, payload).subscribe(
            (result: any) => {
                this.isLoaded = true;
                this.log.event(
                    AnalyticEvent.internalPagesEvents.surveyAnswerSubmitted
                );
                this.savedUserQuizId = result.UserQuizID;
                if (isComplete) {
                    this.log.event(
                        AnalyticEvent.internalPagesEvents.surveySubmitted
                    );
                    if (this.apiDAta === 'UserFeedbackSurvey') {
                        this.storage.set('userFeedbackQnAnswer', {}, true);
                        if (this.forceSave) {
                            this._router.navigate([
                                '/app/surveys',
                                this.user.npsSurveyId,
                                'npsSurvey',
                            ]);
                        } else {
                            this._router.navigate(['/app']);
                        }

                        this.modalService.showAlert(
                            'Success',
                            this.translation.feedbackSuccess
                        );
                        this.isSubmitted = false;
                        this.showUserSurvey = false;
                        this.showNpsSurvey = true;
                        this._router.events.subscribe(event => {
                            if (event instanceof NavigationEnd) {
                                this.showNPSSurvey();
                            }
                        });
                        setTimeout(() => {
                            this.slideIndex = 0;
                        }, 100);
                    } else {
                        this.showNpsSurvey = false;
                        this.modalService.showAlert(
                            'Success',
                            this.translation.RatingSuccess
                        );
                        this._router.navigate(['/app']);

                        setTimeout(() => {
                            this.slideIndex = 0;
                        }, 100);
                    }
                    this.userService.reloadUser();
                } else {
                    this.slideIndex++;
                    this.focusCurrentStep();
                }
            },
            (error: any) => {
                this.isLoaded = true;
                this.log.event(
                    AnalyticEvent.internalPagesEvents.surveyAnswerSubmitError
                );
                this.modalService.showAlert('Error', error.message);
                //   this.loader.close();
                //   this.modalCtrl.dismiss({ save: false });
            },
            () => {}
        );
    }
    onPrevious() {
        if (this.slideIndex <= 0) {
            return;
        }
        this.slideIndex--;
        this.focusCurrentStep();
        const index = this.finalData.findIndex(fd => {
            return fd.id === this.formData[this.slideIndex].ID;
        });
        // this.optionType = this.finalData[index].name;
        this.optionType =
            this.finalData[index] && this.finalData[index].name
                ? this.finalData[index].name
                : '';
    }

    updateDates(data, field) {
        const selectedYear = this.dynamicForm.get('selectedYear').value;
        const selectedMonth = this.dynamicForm.get('selectedMonth').value;
        const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
        // this.dates = Array.from({ length: daysInMonth }, (_, i) => i + 1);
        this.dates = Array.from({ length: daysInMonth }, (_, i) =>
            (i + 1).toString().padStart(2, '0')
        );
        field == 'selectedMonth' &&
            this.dynamicForm.get('selectedDate').setValue('');
        this.dynamicForm.get(data.Key).setErrors({ required: true });
    }
}
